<template>
    <div>
        <!-- 操作证书审核（小程序） -->
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <router-link :to="`/certificatecheckjxshop/${checkactiveorgan}${pageIndex}`">
                        <i class="el-icon-arrow-left"></i>
                        操作证审核 / 厂商业务员
                    </router-link>
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="purchasesee-box">
            <p class="purchasesee-title">用户信息</p>
            <div class="purchasesee-padding">
                <ul class="seelicense-item1">
                    <li>姓名:{{seecerApplylist.ownerName}}</li>
                    <!-- <li>身份证号:{{seecerApplylist.ownerIdentityCards}}</li> -->
                    <li>联系电话:{{seecerApplylist.ownerCellphoneNumber}}</li>
                </ul>
                <ul class="seelicense-item1">
                    <li>地区:{{seecerApplylist.provinceName}}{{seecerApplylist.cityName}}</li>
                    <li>身份证号:{{seecerApplylist.ownerIdentityCards}}</li>
                </ul>
                <ul class="seelicense-itemphoto" v-if="seecerApplylist.ownerIdentityCardsPhoto">
                    <li>身份证照片:</li>
                    <li v-for="item in seecerApplylist.ownerIdentityCardsPhoto">
                        <img :src="'/api/static'+item" alt />
                    </li>
                </ul>

                <ul class="seelicense-itemphoto" v-if="seecerApplylist.ownerCredentialsPhoto">
                    <li>证件照片:</li>
                    <li>
                        <img :src="'/api/static'+seecerApplylist.ownerCredentialsPhoto" alt />
                    </li>
                </ul>
            </div>
            <p class="purchasesee-title">基本信息</p>
            <div class="purchasesee-padding">
                <ul class="seelicense-item3">
                    <li>证书编码：{{seecerApplylist.operationCertificateNumber}}</li>
                    <li>申请时间: {{seecerApplylist.createTimeStr}}</li>
                </ul>
                <ul class="seelicense-item3">
                    <li>操作项目：{{seecerApplylist.operationItems}}</li>
                    <li>有效起止日期: {{seecerApplylist.validDate}}</li>
                </ul>
                <ul class="seelicense-item3">
                    <li>培训起止日期：{{seecerApplylist.studyDate}}</li>
                    <li
                        v-if="seecerApplylist.isFirst != undefined &&seecerApplylist.isFirst == 2"
                    >本证属：换发 岗龄{{seecerApplylist.workAge}}年</li>
                    <li v-else>本证属：初次颁发 岗龄{{seecerApplylist.workAge}}年</li>
                </ul>
            </div>
            <p class="purchasesee-title" v-if="seecerApplylist.shippingAddress">邮寄地址</p>
            <div class="purchasesee-padding">
                <p
                    class="seelicense-item5"
                    v-if="seecerApplylist.shippingName"
                >收货人姓名: {{seecerApplylist.shippingName}}</p>
                <p
                    class="seelicense-item5"
                    v-if="seecerApplylist.shippingCellphoneNumber"
                >收货人手机号: {{seecerApplylist.shippingCellphoneNumber}}</p>
                <p
                    class="seelicense-item5"
                    v-if="seecerApplylist.shippingAddress"
                >收货地址: {{seecerApplylist.shippingAddress}}</p>
            </div>
        </div>

        <p v-if="seecerApplylist.status == 5" style="margin-top: 20px;">
            <el-button type="primary" @click="passcerfirst()">通过</el-button>
            <el-button type="primary" @click="fallbackcerfirst('fallbackform')">退回</el-button>
        </p>

        <el-dialog class="branch-dialog" title="退回原因" :visible.sync="fallbackVisible" width="600px">
            <el-form ref="fallbackform" :model="fallbackform">
                <el-form-item label prop="auditReason">
                    <el-input
                        type="textarea"
                        v-model="fallbackform.auditReason"
                        placeholder="请输入回退原因"
                        class="resizeNone"
                    ></el-input>
                </el-form-item>
            </el-form>

            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="savefallbackfirst()">确 定</el-button>
                <el-button @click="fallbackVisible = false">取 消</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import {getCertificateApply,examineCertificateApply} from '@/api/index';
export default {
    name: 'cercheckseefjxfirst',
    data() {
        return {
			certificateApplyId:'',
			checkactiveorgan:'',
			pageIndex:'',
			seecerApplylist:{},//查看
			fallbackVisible:false,
			fallbackform:{
				auditReason:''
			},
			cerArrId:[]
        };
    },
    created() {
		this.certificateApplyId = this.$route.params.certificateApplyId;
		this.checkactiveorgan = this.$route.params.checkactiveorgan
		this.pageIndex = this.$route.params.pageIndex
		
		this.cerArrId.push(this.$route.params.certificateApplyId);
		// 查看
		getCertificateApply({},{
			"certificateApplyId": this.certificateApplyId         
		}).then(res => {
					  // 获取数据成功后的其他操作
			this.seecerApplylist = res.data;  
				  if(res.data.ownerIdentityCardsPhoto){
				  			this.seecerApplylist.ownerIdentityCardsPhoto = res.data.ownerIdentityCardsPhoto.split(',');
				  }
				  
		});
		
    },
    methods: {
		//审核通过
		passcerfirst(){
			var that = this;
			this.$confirm('确定要通过吗？', '提示', {
			    type: 'warning'
			}).then(() => {
			        examineCertificateApply({
			        	isPass:1,                    
			        	certificateApplyIds: this.cerArrId              
			        }).then(res => {
						if(res.code == 0){
							// 获取数据成功后的其他操作
							this.$message({
							  message: res.message,
							  type: 'success'
							});
							this.$router.push('/certificatecheckjxshop');
							listTaskRemindNum({}).then(ress => {
								   this.$store.state.totalNum =  ress.data.totalNum;
							});
						}else {
							this.$message({
							  message: res.message,
							  type: 'error'
							});
						}
			        	
			        });
			}).catch(() => {});
			
		  },
		  // 回退弹框
		  fallbackcerfirst(formName){
		  	
		  	this.fallbackVisible = true;
		  	//重置表单数据
		  	this.$nextTick(()=>{
		  	  this.$refs.[formName].resetFields();
		  	})
		  	
		  	
		  },
		  
		  //审核退回
		  savefallbackfirst(){
		  	this.$confirm('确定要退回吗？', '提示', {
		  	    type: 'warning'
		  	}).then(() => {
		  	        examineCertificateApply({
		  				auditReason:this.fallbackform.auditReason,
		  	        	isPass:2,                    
		  	        	certificateApplyIds: this.cerArrId             
		  	        }).then(res => {
						if(res.code == 0){
							// 获取数据成功后的其他操作
							this.$message({
							  message: res.message,
							  type: 'success'
							});
							this.fallbackVisible = false;
							this.$router.push('/certificatecheckjxshop');
							listTaskRemindNum({}).then(ress => {
								   this.$store.state.totalNum =  ress.data.totalNum;
							});
						}else {
							this.$message({
							  message: res.message,
							  type: 'error'
							});
						}
						
						
		  	        });
		  	}).catch(() => {});
		  },
		  
	
    }
};
</script>

<style scoped>
.purchasesee-box {
    background: #fff;
    padding: 20px 0;
}
.purchasesee-title {
    height: 30px;
    line-height: 30px;
    background: #f0f0f0;
    font-size: 16px;
    font-weight: 600;
    letter-spacing: 2px;
    border-left: 5px solid #437af4;
    text-indent: 30px;
}
.purchasesee-padding {
    padding: 20px 0;
}
.seelicense-item1 {
    display: flex;
    display: -webkit-flex;
    padding: 0 35px;
    list-style: none;
    color: #666;
    letter-spacing: 1px;
    margin-bottom: 20px;
}
.seelicense-item1 li {
    width: 200px;
    margin-right: 20px;
}
.seelicense-item1 li:last-child {
    flex: 1;
}
.seelicense-itemphoto {
    display: flex;
    display: -webkit-flex;
    flex-wrap: wrap;
    list-style: none;
    padding-left: 35px;
    color: #666;
}
.seelicense-itemphoto li {
    width: 200px;
    margin-right: 20px;
}
.seelicense-itemphoto li:first-child {
    width: 100px;
}
.seelicense-itemphoto li img {
    width: 100%;
}
.seelicense-item2 {
    padding: 0 35px;
    margin-top: 15px;
    color: #666;
    letter-spacing: 1px;
}
.seelicense-item3 {
    display: flex;
    display: -webkit-flex;
    padding: 0 35px;
    list-style: none;
    color: #666;
    letter-spacing: 1px;
    margin-bottom: 10px;
}
.seelicense-item3 li {
    width: 350px;
}
.seelicense-item4 {
    margin: 0 35px;
    background: #f8f8fb;
    padding: 20px;
    list-style: none;
    color: #666;
    letter-spacing: 1px;
}
.seelicense-item4 li {
    margin-bottom: 10px;
}
.seelicense-item5 {
    padding-left: 35px;
    height: 32px;
    line-height: 32px;
    letter-spacing: 1px;
    color: #666;
}
.purchasesee-text1,
.purchasesee-text2 {
    height: 32px;
    line-height: 32px;
    text-indent: 15px;
}

.purchasesee-text2 {
    text-indent: 50px;
}
.purchasesee-table {
    width: 50%;
    margin: 10px 0 30px 50px;
}
.purchasesee-linceinfo {
    margin: 10px 50px;
    display: flex;
    display: -webkit-flex;
}
.purchasesee-linceitem {
    width: 30%;
}
.purchasesee-linceitem:nth-child(2) {
    margin: 0 3%;
}

.organ-box {
    margin-bottom: 20px;
    text-align: right;
}
.apply-box {
    display: flex;
    display: -webkit-flex;
}
.apply-box p {
    flex: 1;
}

.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
</style>
<style>
.apply-flex p .el-form-item__label {
    width: 80px;
}
.resizeNone .el-textarea__inner {
    resize: none;
}

.branch-dialog .el-dialog__header {
    background: #409eff;
    padding: 10px 20px;
}
.branch-dialog .el-dialog__header .el-dialog__title {
    color: #fff;
}
</style>